<div class="presenter-zoom-tools">
  <div class="presenter-zoom-tools-inner">
    <mat-slider min="0.25" max="5" step="0.01">
      <input matSliderThumb [value]="zoomLevel()()" (input)="onZoomChange($event)" />
    </mat-slider>

    <button mat-button class="zoom-percent-button" [matMenuTriggerFor]="zoomMenu" type="button">
      {{ getZoomPercentLabel() }}
    </button>

    <mat-menu #zoomMenu="matMenu">
      @for (preset of zoomPresets; track preset) {
        <button mat-menu-item type="button" (click)="setZoom(preset)">
          {{ formatLabel(preset) }}
        </button>
      }

      <mat-divider></mat-divider>

      <button mat-menu-item type="button" (click)="zoomToFit()">
        {{ 'PRESENTER.ZOOM_FIT' | translate }}
      </button>
      <button mat-menu-item type="button" (click)="zoomToFill()">
        {{ 'PRESENTER.ZOOM_FILL' | translate }}
      </button>
    </mat-menu>
  </div>
</div>
